import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { EditSettingsModel,GridComponent,IEditCell,ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { GridModule, EditService, ToolbarService, SortService } from '@syncfusion/ej2-angular-grids';
import { ApiService } from 'src/app/_services/api.service';
import { GlobalService } from 'src/app/_services/global.service';
import { TextBox } from '@syncfusion/ej2-inputs';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-qualificheutenti',
  templateUrl: './qualificheutenti.component.html',
  styleUrls: ['./qualificheutenti.component.css'],
  providers: [EditService, ToolbarService, SortService,MessageService]

})
export class QualificheutentiComponent implements OnInit {
  @ViewChild('grid')
  public grid: any;
  public editSettings?: EditSettingsModel;
  public toolbar?: ToolbarItems[];
  public dataList?: object[];
  public dpParams: IEditCell;
  public elemContent: HTMLElement;
  public textEditor: TextBox;
  public disableHtmlEncode;
  public valueAccessor = (field: string, data: object, column: object) => {
    var value = data[field];
    if (value != undefined) {
      return value.split('\n').join('<br>');
    } else {
      return '';
    }
  };
  constructor(
    private apiService: ApiService,
    private globalService: GlobalService,
    private messageService: MessageService,


  ) { }

  ngOnInit(): void {
    this.disableHtmlEncode = false;
    this.dpParams = {
      create: () => {
        this.elemContent = document.createElement('textarea');
        return this.elemContent;
      },
      read: () => {
        return this.textEditor.value;
      },
      destroy: () => {
        this.textEditor.destroy();
      },
      write: (args) => {
        this.textEditor = new TextBox({
          multiline: true,
          value: args.rowData[args.column.field],
          floatLabelType: 'Auto',
        });
        this.textEditor.appendTo(this.elemContent);
      },
    };
    this.editSettings = { allowEditing: true, allowAdding: true, allowDeleting: true, mode: 'Normal' };
    this.toolbar = ['Add', 'Edit', 'Delete', 'Update', 'Cancel'];
    
    this.apiService.get('organizationchart/getqualifiche',{}).subscribe((data)=>{
      this.dataList=[];
      data.Result.forEach((d)=>{
        this.dataList.push({
          id:d.id,
          qualifica:d.qualifica
        });
      });
    });
    
  }
  created(args) {
    this.grid.keyConfigs.enter = '';
  }
  save(){
    let error=false;
 
    this.dataList.forEach((d:any,ind)=>{
 //     (this.dataList[ind] as any).qualifica=(this.dataList[ind] as any).qualifica.substring(50);
    });

    if(this.dataList.filter((x:any)=> x.qualifica=='' ).length>0){
      this.addSingle('error',"Attenzione", 'Non ci possono essere app senza nome');
      error=true;
    }
 
  

    this.apiService.get('organizationchart/updatequalifiche',{qualifichelist:this.dataList}).subscribe(data => {
      this.addSingle('success', 'Successo', 'Elenco salvato');
    });

    

  }
  addSingle(sev: string, sum: string, det: string) {
    this.messageService.add({severity: sev, summary: sum, detail: det});
  }
 
}
